import { InputText } from 'primereact/inputtext';
import { Dropdown, DropdownChangeEvent, DropdownFilterEvent } from 'primereact/dropdown';
import { useEffect, useState } from 'react';
import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox';
import { userOption } from '../../models/orders/order-list-model';
import orderServices from '../../services/orders/orderservice';
import { ExecutiveList } from '../../models/CustomerExecutive/CustomerExecutive-model';
import CustomerExecutiveService from '../../services/CustomerExecutives/CustomerExecutivesservice';
import { MultiSelect } from 'primereact/multiselect';
import { Calendar } from 'primereact/calendar'; 



interface AssignExecutiveSearchProps {
  onSearch: (filters: {
    customerId?: number | string;
    salesExecutiveIds?: number[];
    unassignedOnly?: boolean;
    startDate?: string;
    endDate?: string;
  }) => void;
  onReset: () => void;
  totalRecords: number;
}



const AssignExecutiveSearch: React.FC<AssignExecutiveSearchProps> = ({ 
    onSearch, 
    onReset,
    totalRecords
  
}) => {
    const [customerName, setCustomerName] = useState<string>('');
    const [phoneNumber, setPhoneNumber] = useState<string>('');
    const [executiveId, setExecutiveId] = useState<number | null>(null);
    const [notAssignedOnly, setNotAssignedOnly] = useState(false);
    const blankUserDetail: userOption[] = [{ userID: 0, name: 'Not found', primaryContactNbr: '' }];
    const [orderUser, setOrderUser] = useState<any[]>([]);
    const [Executivelist, setExecutivelist] = useState<ExecutiveList[]>([]);   
    const [searchExecutivelist, setsearchExecutivelist] = useState<number[]>([]);
    const [dropdownValue, setDropdownValue] = useState<string | null>(null);
  const [filterApplied, setFilterApplied] = useState(false);
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);

  const EXEC_SELECTED_CUSTOMER_KEY = "selectedCustomerExecutiveUserId";
  const notifyExecutiveSelection = () => {
    window.dispatchEvent(new CustomEvent("executive-customer-selected"));
  };

  
    
    const [orderUsers, setOrderUsers] = useState<userOption[]>(blankUserDetail);
    const [selectedUser, setSelectedUserState] = useState<any>(null);
   const FetchExecutiveList = async () => {
  const executivesFromAPI = await CustomerExecutiveService.getCustomerExecutiveList();
  const withUnassigned = [
    { salesExecutiveId: 0, salesExecutiveName: "Unassigned Customers" },
    ...executivesFromAPI
  ];
  setExecutivelist(withUnassigned);
};


const handleExecutiveChange = (e: any) => {
  const selected = e?.value ?? [];
  setsearchExecutivelist(selected);

 
  setNotAssignedOnly(selected.includes(0));

  const cleanedExecutives = selected.filter((id: number) => id !== 0);
  setExecutiveId(cleanedExecutives);
};

const toLocalISOString = (date: Date): string => {
  const offsetMs = date.getTimezoneOffset() * 60000;
  const localTime = new Date(date.getTime() - offsetMs);
  return localTime.toISOString().split('T')[0];
};


const handleSearch = () => {
  onSearch({
  
    customerId: dropdownValue || undefined,
    salesExecutiveIds:
      searchExecutivelist?.filter((id) => id !== 0) ?? undefined,
    unassignedOnly: notAssignedOnly ? true : undefined,
    // startDate: startDate ? startDate.toISOString() : undefined,
    // endDate: endDate ? endDate.toISOString() : undefined
    startDate: startDate ? toLocalISOString(startDate) : undefined,
endDate: endDate ? toLocalISOString(endDate) : undefined,

  });
  setFilterApplied(true); 
};

    const handleReset = () => {
        setCustomerName('');
        setPhoneNumber('');
         setDropdownValue("");
         handleExecutiveChange("");
         setFilterApplied(false);
         setStartDate(null);
        setEndDate(null);
        localStorage.removeItem(EXEC_SELECTED_CUSTOMER_KEY);
        notifyExecutiveSelection();

        onReset();
    };

      useEffect(() => {
        FetchExecutiveList();

        
        
     if (orderUsers.length > 0) {
      setOrderUser(orderUsers.map((user) => ({
        userID: user.userID,
        detail: user.userID !== 0 ? `${user.name}, ${user.primaryContactNbr}` : "",
      })));
    }
  }, [orderUsers]);

   const handleDropdownChange = (e: DropdownChangeEvent) => {
    const selectedUserId = e.value;
    const selectedUser = orderUser.find(user => user.userID === selectedUserId);
    
 
    if (selectedUser) {
      const [name, primaryContactNbr] = selectedUser.detail.split(",").map((item: string) => item.trim());
      setSelectedUserState({ name, primaryContactNbr });
       setDropdownValue(selectedUserId);
       setCustomerName(selectedUserId);
      if (selectedUserId) {
        localStorage.setItem(EXEC_SELECTED_CUSTOMER_KEY, String(selectedUserId));
      } else {
        localStorage.removeItem(EXEC_SELECTED_CUSTOMER_KEY);
      }
      notifyExecutiveSelection();
    } else {
      setDropdownValue(null);
      localStorage.removeItem(EXEC_SELECTED_CUSTOMER_KEY);
      notifyExecutiveSelection();
    }
  };


   const handleDropdownFilter = (e: DropdownFilterEvent) => {
    if (e.filter.length > 0) {
      orderServices.getOrderUsers(e.filter).then((response: userOption[]) => {
        if (response.length > 0) {
          setOrderUsers(response);
        }
      });
    }
  };

    return (
        <div className="col-12">
            <div className="card border-noround p-3" style={{ minHeight: '3.5rem' }}>
              <div className="flex flex-wrap align-items-center gap-3">
              <div className="col-12 md:col-4" style={{ paddingBottom: "10px" }}>
             <Dropdown
              id="SearchUser"
              name="SearchUser"
              options={orderUser || []}
              optionLabel="detail"
              optionValue="userID"
              value={dropdownValue}
              onChange={handleDropdownChange}
               onFilter={handleDropdownFilter}
               filter
               placeholder="Search for Customer/Mobile"
               style={{ width: '80%', maxWidth:'80%'}}
                 />
                  </div>                
                    <div style={{ flex: '1 1 30%' }}>
                        <MultiSelect
                                      id="salesExecutiveId"
                                      name="salesExecutiveName"
                                      options={Executivelist}
                                      optionLabel="salesExecutiveName"
                                      optionValue="salesExecutiveId"
                                      value={searchExecutivelist}
                                      display="chip"
                                      onChange={handleExecutiveChange}
                                      placeholder="Select Executive"
                                      style={{ width: "80%" }}
                                    />
                          </div>
                    
                    <div className="flex gap-2 justify-content-end ml-auto" style={{ flex: '1 1 30%' }}>
                        <Button
                            className="text-black border-round p-button-m"
                            severity="success"
                            raised
                            label="Filter"
                            style={{ width: "50%", marginRight:'20px'}}
                            onClick={handleSearch}
                        />
                        <Button
                            className="text-black border-round p-button-m"
                            severity="secondary"
                            text
                            raised
                            label="Reset"
                            style={{ width: "50%"}}
                            onClick={handleReset}
                        />
                        </div>
                       <div className="flex flex-wrap gap-3 mt-3">
                       <div style={{ flex: '1 1 20%' }}>
                       <Calendar
                       value={startDate}
                       onChange={(e) => setStartDate(e.value as Date)}
                       placeholder="Start Date"
                       dateFormat="dd-mm-yy"   
                      style={{ width: '100%',marginLeft:'10px' }}
                      />
                       </div>

  <div style={{ flex: '1 1 20%' }}>
    <Calendar
      value={endDate}
      onChange={(e) => setEndDate(e.value as Date)}
      placeholder="End Date"
      dateFormat="dd-mm-yy"    
      style={{ width: '100%',marginLeft:'10px' }}
    />
  </div>
</div>


                        {filterApplied && (
           <div className="col-12 mt-2 ml-3 text-sm">
         <span className="font-bold text-blue-600">
      {
        searchExecutivelist.length > 0
          ? Executivelist          
    .filter(exec => exec.salesExecutiveIds?.some(id => searchExecutivelist.includes(id)))

              .map(exec => exec.salesExecutiveName)
              .join(", ")
          : notAssignedOnly
              ? "Unassigned Customers"
              : ""
      }
    </span>
    <span className="text-black font-semibold text-lg">
  Number of Customers: {totalRecords}
</span>
  </div>
)}
        </div>
        </div>
        </div>
    );
};

export default AssignExecutiveSearch;
